import type { PosSaleLine } from '../types';

export const buildLineKey = (itemId: number, variantId: number | null | undefined): string => {
  const normalizedVariant = variantId ?? 'base';
  return `${itemId}-${normalizedVariant}`;
};

export const resolveLineKey = (line: PosSaleLine): string => {
  return line.lineKey ?? buildLineKey(line.item.id, line.variantId ?? null);
};
